import file from '../common/file';
import { categories } from './extensionIcons';
import generateVideoThumbnail from './generateVideoThumbnail';
import resizeImage from './resizeImage';

const generateThumbnail = async (file: file, signedUrl: string) => {
	if (categories.images.includes(file.extension)) {
		const res = await fetch(signedUrl);
		const image = await res.blob();
		const resized = await resizeImage(image);
		return resized;
	} else if (categories.videos.includes(file.extension)) {
		const thumbnail = await generateVideoThumbnail(signedUrl);
		return thumbnail;
	}
	return undefined;
};

export default generateThumbnail;
